import { ClassicPreset } from 'rete'

/**
 * Example
 */
export class ButtonControl extends ClassicPreset.Control {
  label: string
  onClick: () => void
  constructor(label: string, onClick: () => void) {
    super()
    this.label = label
    this.onClick = onClick
  }
}
